"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var caretDownSvg = require("../../icons/caretDown-16.svg");

var Icon_1 = require("../../icons/Icon");

var styles_1 = require("./styles");

function Dropdown(props) {
  var children = props.children,
      _a = props.ctaColor,
      ctaColor = _a === void 0 ? colors_1.comet : _a,
      _b = props.ctaHoverBackgroundColor,
      ctaHoverBackgroundColor = _b === void 0 ? colors_1.merino : _b,
      _c = props.letterSpacing,
      letterSpacing = _c === void 0 ? false : _c,
      _d = props.uppercase,
      uppercase = _d === void 0 ? false : _d,
      _e = props.minContentWidth,
      minContentWidth = _e === void 0 ? 248 : _e,
      _f = props.icon,
      icon = _f === void 0 ? caretDownSvg : _f,
      _g = props.iconHeight,
      iconHeight = _g === void 0 ? 16 : _g,
      _h = props.iconWidth,
      iconWidth = _h === void 0 ? 16 : _h,
      position = props.position,
      text = props.text,
      _j = props.textProps,
      textProps = _j === void 0 ? {} : _j;
  var isIconButton = !text && icon;
  return React.createElement("div", __assign({
    className: "dropdown"
  }, styles_1.dropdownStyle({
    ctaHoverBackgroundColor: ctaHoverBackgroundColor,
    isIconButton: isIconButton
  })), React.createElement("div", __assign({
    className: "dropdownCta"
  }, styles_1.dropdownCtaStyle({
    ctaColor: ctaColor,
    ctaHoverBackgroundColor: ctaHoverBackgroundColor,
    letterSpacing: letterSpacing,
    uppercase: uppercase,
    isIconButton: isIconButton
  }), font_1.bold), text ? React.createElement("div", __assign({}, styles_1.textStyle, textProps), text) : null, React.createElement(Icon_1.Icon, {
    width: iconWidth,
    height: iconHeight,
    fill: ctaColor,
    src: icon
  })), React.createElement("div", __assign({
    className: "dropdownContent " + styles_1.positionStyle(position)
  }, styles_1.dropdownContentStyle({
    minWidth: minContentWidth
  })), React.createElement("div", __assign({}, styles_1.dropdownItemsStyle()), children)));
}

exports.Dropdown = Dropdown;

function DropdownLink(props) {
  var href = props.href,
      children = props.children,
      others = __rest(props, ["href", "children"]);

  return React.createElement("a", __assign({
    className: "dropdownLink",
    href: href
  }, styles_1.dropdownDisplayStyle, styles_1.dropdownItemStyle, font_1.regular, others), children);
}

exports.DropdownLink = DropdownLink;

function DropdownItem(props) {
  var onClick = props.onClick,
      children = props.children,
      others = __rest(props, ["onClick", "children"]);

  return React.createElement("div", __assign({
    className: "dropdownItem",
    onClick: onClick
  }, styles_1.dropdownDisplayStyle, styles_1.dropdownItemStyle, font_1.regular, others), children);
}

exports.DropdownItem = DropdownItem;